import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeProgramsSection'
 * @name TypeProgramsSectionFields
 * @type {TypeProgramsSectionFields}
 * @memberof TypeProgramsSection
 */
export interface TypeProgramsSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor?: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'programsSection' (Programs Section)
 * @name TypeProgramsSectionSkeleton
 * @type {TypeProgramsSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T18:33:35.660Z
 * @version 9
 */
export type TypeProgramsSectionSkeleton = EntrySkeletonType<TypeProgramsSectionFields, "programsSection">;
/**
 * Entry type definition for content type 'programsSection' (Programs Section)
 * @name TypeProgramsSection
 * @type {TypeProgramsSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-24T18:33:35.660Z
 * @version 9
 */
export type TypeProgramsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeProgramsSectionSkeleton, Modifiers, Locales>;

export function isTypeProgramsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeProgramsSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'programsSection'
}
